<template lang="pug">
div
	lessonHeader
	lessonTitle
	div.button3
		arrowReturn
	div.block
		div.cube
			div.imagescen
				imageLoader
			div.title
				initialText.textcen
		div.oval
		div.oval2
	div
		buttonNext2.button
	lessonFooter
</template>

<script>

import lessonHeader from "@/components/lesson-header/lesson-header";
import lessonTitle from '@/components/lesson-title/lesson-title'
import stepTitle2 from '@/components/step-title2/step-title2'
import buttonNext2 from '@/components/button-next/button-next2'
import arrowReturn from '@/components/button-return/arrow-return'
import initialText from '@/components/initial-text/initial-text'
import lessonFooter from "@/components/lesson-footer/lesson-footer";
import imageLoader from "@/components/image-loader/image-loader";

export default {
	name: 'Escenario3',
	components:{
		lessonHeader,
		lessonTitle,
		stepTitle2,
		buttonNext2,
		arrowReturn,
		initialText,
		lessonFooter,
		imageLoader
	}
}
</script>

<style scoped>
@import 'escenario2.scss';
</style>